const IconToggleOffSwitch = (): JSX.Element => {
  return (
    <>
      <path
        d="M0 12C0 8.13401 3.13401 5 7 5H17C20.866 5 24 8.13401 24 12C24 15.866 20.866 19 17 19H7C3.13401 19 0 15.866 0 12Z"
        fill="currentColor"
      />
      <path
        d="M2 12C2 9.23858 4.23858 7 7 7C9.76142 7 12 9.23858 12 12C12 14.7614 9.76142 17 7 17C4.23858 17 2 14.7614 2 12Z"
        fill="white"
      />
    </>
  );
};

export default IconToggleOffSwitch;
